export default "__VITE_ASSET__DASNl4Xk__"